import React from "react";
import { api } from "../../config";

function PrintComponent({ children, item }) {
  return (
    <>
      <table className='print-component'>
        <thead>
          <tr>
            <th>
              <img
                src={
                  item.data.task_client
                    ? api.MEDIA_URL + "/media/" + item.data.task_client.image
                    : null
                }
                height={"35px"}
                width={"115px"}
                alt='logo'
                style={{ marginTop: "70px", marginBottom: "40px" }}/>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{children}</td>
            <tfoot className='table-footer'>
              <tr>
                <td
                  style={{
                    position: "fixed",
                    bottom: "0",
                    marginLeft: "80px",
                  }}>
                  <h5>{item.data.task_client.name}</h5>
                  <h6>{`${item.data.task_client.client_address[0].village}, ${item.data.task_client.client_address[0].district}, ${item.data.task_client.client_address[0].city} ${item.data.task_client.client_address[0].code}`}</h6>
                  <h6>{`Tel. ${item.data.task_client.phone} | Fax. ${item.data.task_client.fax} | ${item.data.task_client.domain}`}</h6>
                </td>
              </tr>
            </tfoot>
          </tr>
        </tbody>
      </table>
      <style>
        {`
.print-component {
  display: none;
  @media print {
    display: table;
    .table-footer > tr > td{
      text-align: left;
      background-color: white;
      color: white;
      margin-top: 50px;
    }
  }
}`}
      </style>
    </>
  );
}

export default PrintComponent;
